import { Component, inject } from '@angular/core';
import {EmailDialogDataModel} from './email-dialog-data.model';
import { UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import {EmailAddress} from '@shared/objects/email-address';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { MatToolbar } from '@angular/material/toolbar';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';

@Component({
    templateUrl: 'send-email-dialog.component.html',
    styleUrls: ['send-email-dialog.component.scss'],
    imports: [MatToolbar, MatIcon, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatButton]
})
export class SendEmailDialogComponent {
  private dialogRef = inject<MatDialogRef<SendEmailDialogComponent>>(MatDialogRef);
  private formBuilder = inject(UntypedFormBuilder);
  data = inject<EmailDialogDataModel>(MAT_DIALOG_DATA);

  title = 'Email verzenden';

  emailForm: UntypedFormGroup;

  constructor() {
    const data = this.data;

    if (data.title) {
      this.title = data.title;
    }

    this.createForm(data);
  }

  createForm(data: EmailDialogDataModel) {
    this.emailForm = this.formBuilder.group({
      subject: [],
      body: [],
      bcc: [null, [Validators.required, Validators.email]]
    });

    this.emailForm.patchValue({
      subject: data.subject,
      body: data.body
    });
  }

  onClose() {
    this.dialogRef.close();
  }

  onSend() {
    const result = this.emailForm.value;
    const emailAddress = new EmailAddress();
    emailAddress.email = result.bcc;

    result.bcc = [emailAddress];

    result.body = result.body.replace(/(?:\r\n|\r|\n)/g, '<br/>');

    this.dialogRef.close(result);
  }
}
